import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Vehicle } from '../state/types'

export const useVehicleLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const { getList, find } = useStateHooks()
    
    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const findAllVehicles = (active = false) => getList(TableName.VEHICLES, active) as Vehicle[]

        const findVehicle = (id?: string) => find(TableName.VEHICLES, id) as O<Vehicle>

        const loadAllVehicles = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.VEHICLES, options)
            return response.dataTypes as Vehicle[]
        }

        const loadVehicle = (id: string, dbRequest = false) => {
            const { load } = loaders(companyId)
            return load(TableName.VEHICLES, id, dbRequest) as Promise<O<Vehicle>>
        }

        return {
            findAllVehicles,
            findVehicle,
            loadAllVehicles,
            loadVehicle
        }
    }
}
